import React from "react"
import { useStore } from "../../teafuljs/store"
import SourceIcons from "../../data/SourceIcons.json"
import BookList from "../../data/BookChapterList.json"
import IconButton from "@material-ui/core/IconButton"
import RssFeed from "@material-ui/icons/RssFeed"
import sortBooks from "../../scripts/sortBooksByBibleOrder"
import SourceMetadata from "../SourceMetadata/SourceMetadata"
import { getTranslation } from "../../scripts/getTranslation"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
  container: {
    margin: -10,
    fontSize: "80%",
  },
  speakingIcon: {
    transform: "rotate(45deg)",
  },
  SVicons: {
    height: "50px",
    width: "50px",
  },
  narratorIcon: {
    height: "100px",
    width: "100px",
  },
  SVBInfoTable: {
    tableLayout: "fixed",
    // position: "relative",
    width: "100%",
    height: "fit-content",
    margin: 0,
    padding: 0,
    borderSpacing: 0,
    borderCollapse: "collapse",
    fontSize: "90%",
  },
  row: {
    width: "100%",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
  },
  header: {
    fontWeight: "bold",
    backgroundColor: "lightgrey",
    border: "1px black solid",
    paddingRight: 2,
    paddingLeft: 2,
    fontSize: "80%",
  },
  leftCell: {
    wordWrap: "break-word",
    flex: 1,
  },
  middleCell: {
    wordWrap: "break-word",
    whiteSpace: "normal",
    maxWidth: "45%",
    flex: 1,
  },
  rightCell: {
    wordWrap: "break-word",
    flex: 1,
    textAlign: "right",
  },
  rightIcon: {
    wordWrap: "normal",
    flex: 1,
    textAlign: "center",
  },
  leftIcon: {
    wordWrap: "break-word",
    flex: 1,
    textAlign: "center",
  },
  cellTitle: {
    textDecoration: "underline",
    fontWeight: "bold",
    marginBottom: "1px",
  },
  narrator: {
    textAlign: "center",
  },
  sourceName: {
    marginTop: 0,
  },
  metadata: {
    display: "block",
    position: "relative",
    marginTop: "10px",
  },
  middleIcon: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  wordCount: {
    fontSize: 10,
    color: "grey",
    lineHeight: 1,
    // border: '2px solid grey',
    // borderRadius: '5%',
    padding: "5px",
    textAlign: "center",
  },
})

const NT = Object.keys(BookList).slice(40)

const SourceViewInfo = props => {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const [stateMetadata, setMetadata] = useStore.metadata();
  const classes = useStyles()
  const SVBData = props.content
  const sourceName =
    SVBData.color !== "black"
      ? SVBData.source || SVBData.sourceName
      : SVBData.unique_sources[0]
  console.log(sourceName, SVBData.words)
  const metadata = stateMetadata ? stateMetadata[sourceName] : null
  const icon = SourceIcons[sourceName]
    ? SourceIcons[sourceName].sourceIcon
    : "singleBlueMale"
  if (SVBData.color !== "black") {
    let recipList = ``
    SVBData.unique_recipients.map(recip => {
      recipList =
        recipList !== ""
          ? recipList +
            `, ${getTranslation(
              translations,
              language,
              "Sources",
              recip
            )}`
          : recipList +
            `${getTranslation(
              translations,
              language,
              "Sources",
              recip
            )}`
      return null
    })
    return (
      <div className={classes.container}>
        <table className={classes.SVBInfoTable}>
          <tbody>
            <tr className={classes.row}>
              <td className={classes.leftIcon} style={{ textAlign: "center" }}>
                <img
                  src={require(`../../../static/images/${icon}.png`)}
                  className={classes.SVicons}
                  alt="Source Name"
                />
              </td>
              <td className={classes.middleIcon}>
                <IconButton className={classes.speakingIcon} size="medium">
                  <RssFeed size="large" />
                </IconButton>
                {language !== "CMN" && language !== "CMNT" && (
                  <span className={classes.wordCount}>
                    {SVBData.words.length.toLocaleString()}
                    <br />
                    {getTranslation(
                      translations,
                      language,
                      "UI",
                      "sourceview_popup_words"
                    )}
                  </span>
                )}
              </td>
              <td className={classes.rightIcon} style={{ textAlign: "center" }}>
                <img
                  src={
                    SourceIcons[SVBData.unique_recipients[0]] &&
                    SourceIcons[SVBData.unique_recipients[0]].sourceIcon
                      ? require(`../../../static/images/${
                          SourceIcons[SVBData.unique_recipients[0]].sourceIcon
                        }.png`)
                      : require(`../../../static/images/otherGrey.png`)
                  }
                  className={classes.SVicons}
                  alt="Source Name"
                />
              </td>
            </tr>
            <tr className={classes.row}>
              <td className={classes.leftCell} style={{ textAlign: "center" }}>
                <span className={classes.cellTitle}>
                  {getTranslation(
                    translations,
                    language,
                    "UI",
                    "sourceview_popup_source"
                  )}
                </span>
                <br />
                {getTranslation(
                  translations,
                  language,
                  "Sources",
                  SVBData.sourceName
                )}
              </td>
              <td className={classes.middleCell} />
              <td className={classes.rightCell} style={{ textAlign: "center" }}>
                <span className={classes.cellTitle}>
                  {getTranslation(
                    translations,
                    language,
                    "UI",
                    "sourceview_popup_recipient"
                  )}
                </span>
                <br />
                {SVBData.unique_recipients.length !== 1
                  ? recipList
                  : getTranslation(
                      translations,
                      language,
                      "Sources",
                      SVBData.recipientName
                    )}
              </td>
            </tr>
            {metadata ? (
              <React.Fragment>
                <tr className={`${classes.row} ${classes.header}`}>
                  <td className={classes.leftCell}>
                    {getTranslation(
                      translations,
                      language,
                      "UI",
                      "sourceview_popup_book"
                    )}
                  </td>
                  <td className={classes.middleCell}>
                    {getTranslation(
                      translations,
                      language,
                      "UI",
                      "sourceview_popup_occurrences"
                    )}
                  </td>
                  <td className={classes.rightCell}>
                    {getTranslation(
                      translations,
                      language,
                      "UI",
                      "sourceview_popup_words"
                    )}
                  </td>
                </tr>
                {sortBooks(metadata.books).map(book => (
                  <tr className={classes.row}>
                    <td className={classes.leftCell}>
                      {getTranslation(
                        translations,
                        language,
                        "Books",
                        `abbrev_${book}`
                      )}
                    </td>
                    <td className={classes.middleCell}>
                      {metadata.occurrencesByBook[book].toLocaleString()}
                    </td>
                    <td className={classes.rightCell}>
                      {metadata.wordsByBook[book].toLocaleString()}
                    </td>
                  </tr>
                ))}
                <tr className={`${classes.row} ${classes.header}`}>
                  <td className={classes.leftCell}>Total</td>
                  <td className={classes.middleCell}>
                    {metadata.occurrences.toLocaleString()}
                  </td>
                  <td className={classes.rightCell}>
                    {metadata.words.toLocaleString()}
                  </td>
                </tr>
              </React.Fragment>
            ) : null}
          </tbody>
        </table>
        {metadata ? (
          <div className={classes.metadata}>
            <SourceMetadata close={props.close} sourceName={sourceName} />
          </div>
        ) : null}
      </div>
    )
  } else {
    if (SVBData) {
      return (
        <div className={classes.narrator}>
          <img
            src={require(`../../../static/images/${icon}.png`)}
            className={classes.narratorIcon}
            alt="Source Name"
          />
          <p className={classes.cellTitle}>
            {getTranslation(
              translations,
              language,
              "UI",
              "sourceview_popup_source"
            )}
          </p>
          <p className={classes.sourceName}>{`${getTranslation(
            translations,
            language,
            "Sources",
            SVBData.source
          )} (${SVBData.unique_sources
            .map(uniqueS =>
              getTranslation(translations, language, "Sources", uniqueS)
            )
            .join(", ")})`}</p>
        </div>
      )
    }
  }
}

export default SourceViewInfo
